import { z } from 'zod';

import { learningPathOrderingSchema, learningPathStatusSchema } from '../schemas/learningPathsList.schema';

export const learningPathSearchParamsSchema = z.object({
  escola: z.number().optional(),
  busca: z.string().optional(),
  status: learningPathStatusSchema.optional(),
  ordenacao: learningPathOrderingSchema.optional(),
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().positive().optional(),
  tema: z.coerce.number().optional(),
});

export type LearningPathSearchParams = z.infer<typeof learningPathSearchParamsSchema>;
